<template>
  <v-card-text class="card-revisa">
    <h2>Revisa tu correo</h2>
    <p>
      Te hemos enviado un correo con un enlace para restablecer tu contraseña.
      Si no lo encuentras en tu bandeja de entrada, revisa tu carpeta de correo
      no deseado.
    </p>

    <!-- Mostrar solo si NO es portal ECI -->
    <template v-if="!isPortalEci">
      <a href="/" class="btn-back-login">
        <v-icon left>mdi-arrow-left</v-icon>
        Regresar al inicio de sesión
      </a>
    </template>
  </v-card-text>
</template>

<script>
export default {
  name: "RevisaCorreo",
  data() {
    return {
      globalConfig: JSON.parse(localStorage.getItem("globalConfig")) ?? {},
    };
  },
  computed: {
    isPortalEci() {
      const crmName = this.globalConfig?.showCrmName;
      if (crmName) return crmName === "portalEci";

      const host = window.location.hostname.toLowerCase();
      return (
        host.includes("portal-eci") ||
        host.includes("porta-eci") ||
        host.includes("eci") ||
        host.includes("portal-alianzas")
      );
    },
  },
};
</script>

<style scoped>
.card-revisa {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center; /* centra todo el bloque */
  margin-top: 40px;
  padding: 0 20px;
}

/* Título */
h2 {
  font-size: 24px;
  font-weight: 700;
  color: #333333;
  font-family: "Raleway";
  margin-bottom: 12px;
}

/* Párrafo justificado visualmente */
p {
  font-size: 14px;
  font-family: "Montserrat";
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  text-align: justify;
  max-width: 360px;
  margin: 0 auto 40px auto;
}

/* Botón de regreso (solo Interify) */
.btn-back-login {
  color: #333333;
  font-size: 14px;
  font-weight: 400;
  font-family: "Montserrat";
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 10px;
  transition: 0.2s;
}

.btn-back-login:hover {
  color: #00a7e4;
}
</style>
